<div class="{{localService.selectedLanguageCode}}"
  *ngIf="elementIds && localService.languageContent && localService.languageContent.barcode">
  <app-popup-header title="{{localService.languageContent.barcode.header}}"></app-popup-header>
  <div class="row">
    <div class="col-5">
      <div class="row">
        <div class="col-10">
          <input autocomplete="off" type="number" class="number" [ngClass]="barCodeSize ? 'en' : ''"
            style="max-width:200px;" (keypress)="localService.isNumberOnly($event,numericConfig)" [(ngModel)]="barCodeSize"
            placeholder="*{{localService.languageContent.barcode.bar_code_size}}"
            title="*{{localService.languageContent.barcode.bar_code_size}}" (blur)="onSaveLastUsedSettings()" />
        </div>
      </div>
    </div>
    <div class="col-7">
      <button type="button" class="btn btn-primary"
        (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
      &nbsp;
      <button type="button" class="btn btn-primary"
        (click)="onPopupSave(true)">{{localService.languageContent.barcode.print}}</button>
    </div>
  </div>
  <div class="modal-body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <app-qrcode-generator [htmlId]="htmlId" [value]="value" [productId]="productId" [businessId]="businessId" [displayValue]="displayValue"
      [categoryCode]="categoryCode" [isPopup]="true" [isGlobalBarcode]="isGlobalBarcode" [isShowLabelPrint]="isShowLabelPrint" [countryCode]="countryCode" [isQuantityShow]="isQuantityShow">
    </app-qrcode-generator>
  </div>
</div>